export const isProduction = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
